import * as R from "ramda";
import store from "./store";
import { format } from "date-fns";
import es from "date-fns/locale/es";
import * as v from "voca";

const inputValidate = (trigger, required = false, min = null, max = null) => {
  const rules = [];

  // Para validar campos requeridos
  if (required) {
    rules.push({
      required: true,
      message: "Este campo es requerido.",
      trigger,
    });
  }

  // Para validar si tiene min y max o cualquiera
  if (!R.isNil(min) && !R.isNil(max)) {
    rules.push({
      min,
      max,
      message: `Debe contener entre ${min} y ${max} caracteres.`,
      trigger,
    });
  } else if (!R.isNil(min)) {
    rules.push({
      min,
      message: `Debe contener mínimo ${min} caracteres.`,
      trigger,
    });
  } else if (!R.isNil(max)) {
    rules.push({
      max,
      message: `Debe contener máximo ${max} caracteres.`,
      trigger,
    });
  }

  return rules;
};

const amountValidate = (trigger, required = false, min = null, max = null) => {
  const validation = (rule, value, callback) => {
    if ((R.isEmpty(value) || R.isNil(value)) && required) {
      callback(new Error("Este campo es requerido."));
    } else if (typeof parseFloat(value) !== "number") {
      callback(new Error("Ingresa un número valido."));
    } else if (!R.isNil(min) && parseFloat(value) < min) {
      callback(new Error(`El número debe ser mayor a ${min}`));
    } else if (!R.isNil(max) && parseFloat(value) > max) {
      callback(new Error(`El número debe ser menor a ${max}`));
    } else {
      callback();
    }
  };

  return [
    {
      validator: validation,
      trigger,
    },
  ];
};

const emailValidate = (trigger, required = false, min = null, max = null) => {
  const rules = [
    {
      type: "email",
      message: "Debes ingresar un correo válido.",
      trigger: ["blur", "change"],
    },
  ];

  // Para validar campos requeridos
  if (required) {
    rules.push({
      required: true,
      message: "Este campo es requerido.",
      trigger,
    });
  }

  return rules;
};

const sortPropertyName = (property) => {
  return R.sortBy(R.compose(R.toLower, R.prop(property)));
};

const formatMoney = (value) => {
  return value === null || value === ""
    ? ""
    : new Intl.NumberFormat("es-GT", {
      style: "currency",
      currency: "GTQ",
    }).format(value);
};

const formatNumber = (value) => {
  return value === null || value === ""
    ? ""
    : new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximunFractionDigits: 2,
    }).format(value);
};

const calcularPension = (
  country,
  type,
  employer,
  employee,
  salary,
  maximun
) => {
  switch (country.toUpperCase()) {
    case "SV":
      switch (type.toUpperCase()) {
        case "AFP":
        case "IPSFA":
          return {
            employer:
              (parseFloat(salary) > parseFloat(maximun)
                ? parseFloat(maximun)
                : parseFloat(salary)) *
              (parseFloat(employer) / 100),
            employee:
              (parseFloat(salary) > parseFloat(maximun)
                ? parseFloat(maximun)
                : parseFloat(salary)) *
              (parseFloat(employee) / 100),
          };
      }
      break;
  }
};

const calcularSocial = (country, employer, employee, maximun, salary) => {
  switch (country.toUpperCase()) {
    case "SV":
      return {
        employer:
          (parseFloat(salary) > parseFloat(maximun)
            ? parseFloat(maximun)
            : parseFloat(salary)) *
          (parseFloat(employer) / 100),
        employee:
          (parseFloat(salary) > parseFloat(maximun)
            ? parseFloat(maximun)
            : parseFloat(salary)) *
          (parseFloat(employee) / 100),
      };
  }
};

const getHeader = (
  name,
  lastDay,
  docName,
  dateType = "date",
  preTitle = null,
  user
) => {
  let title = docName;
  if (!R.isNil(lastDay)) {
    let date = null;
    switch (dateType) {
      case "date":
        date = format(lastDay, "DD - MMMM - YYYY", { locale: es })
          .split("-")
          .join("de");
        title = `${docName} AL ${date}`;
        break;
      case "month":
        date = format(lastDay, "MMMM - YYYY", { locale: es })
          .split("-")
          .join("de");
        title = `${docName} PARA EL MES DE ${date}`;
        break;
      case "period":
        const fromDate = format(lastDay[0], "DD/MM/YYYY");
        const toDate = format(lastDay[1], "DD/MM/YYYY");
        title = `${docName} EN EL PERÍODO DEL ${fromDate} AL ${toDate}`;
        break;
      case "custom":
        title = `${docName} ${lastDay}`;
        break;
      case "fixed":
        title = `${docName} EN EL PERÍODO DEL ${lastDay[0]} AL ${lastDay[1]}`;
        break;
    }
  }
  return (currentPage, pageCount, pageSize) => {
    let header = [
      {
        columns: [
          {
            text: v.upperCase(name),
            fontSize: 12,
            bold: true,
          },
        ],
        margin: [20, 15, 20, 0],
      },
    ];

    if (!R.isNil(preTitle)) {
      header.push({
        columns: [
          {
            text: preTitle,
            fontSize: 10,
            margin: [0, 5, 0, 0],
          },
        ],
        margin: [20, 0, 20, 0],
      });
    }
    const line = [
      {
        text: v.upperCase(title),
        fontSize: 10,
        margin: [0, 5, 0, 0],
        width: "65%",
      }
    ]
    if (user) {
      line.push({
        text: [
          {
            text: user,
            bold: true
          },
        ],
        fontSize: 9,
        alignment: 'right',
        margin: [0, 5, 0, 0],
        width: '35%'
      })
    }
    header.push(
      {
        columns: line,
        margin: [20, 0, 20, 0],
      },
      {
        canvas: [
          {
            type: "line",
            x1: 20,
            y1: 5,
            x2: pageSize.width - 20,
            y2: 5,
            lineWidth: 1,
          },
        ],
      }
    );
    return header;
  };
};

const getFooter = () => {
  return (currentPage, pageCount, pageSize) => {
    return [
      {
        canvas: [
          {
            type: "line",
            x1: 20,
            y1: 5,
            x2: pageSize.width - 20,
            y2: 5,
            lineWidth: 1,
          },
        ],
      },
      {
        columns: [
          {
            text: `FECHA Y HORA DE IMPRESION: ${format(new Date(), "DD/MM/YYYY HH:mm:ss")}`,
            fontSize: 8,
            margin: [0, 5, 0, 0],
          },
          {
            text: `${currentPage.toString()} / ${pageCount}`,
            fontSize: 9,
            alignment: "right",
            margin: [0, 5, 0, 0],
          },
        ],
        margin: [20, 0, 20, 0],
      },
    ];
  };
};



const buildTableBody = (data, columns) => {
  var body = [];

  body.push(columns);

  data.forEach(function (row) {
    var dataRow = [];

    columns.forEach(function (column) {
      dataRow.push(row[column].toString());
    })

    body.push(dataRow);
  });

  return body;
}

const table = (data, columns) => {
  return {
    table: {
      headerRows: 1,
      body: buildTableBody(data, columns)
    },
    layout: 'noBorders'

  };
}

/**
 * Funcion que permite identificar si hay informacion sin guardar
 * @param {object} self Referencia a this.
 * @param {text} storagekey Nombre de la llave a usar en localstorage
 * @param {function} next Funcion para conginuar
 */

function checkBeforeLeave(self, storagekey, next) {
  const stored = localStorage.getItem(storagekey);
  if (!stored) {
    return next();
  }
  self
    .$confirm(
      "Existe informacion sin guardar. ¿Estas seguro que deseas salir?",
      "Autoguardado",
      {
        confirmButtonText: "Si, salir",
        cancelButtonText: "No, gracias",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false,
      }
    )
    .then(() => {
      localStorage.removeItem(storagekey);
      next();
    });
}

/**
 * Funcion que permite identificar informacion que se dejo pendiente
 * @param {object} self Referencia a this
 * @param {string} storagekey Nombre de la llave a usar en el LocalStorage
 * @param {string} form Name of the object where to store
 */
function checkBeforeEnter(self, storagekey, fieldname, ifFound, elseFound, ifForm, elseForm) {
  const stored = localStorage.getItem(storagekey);
  if (stored) {
    self
      .$confirm(
        "Existe informacion guardada previamente. ¿deseas recuperarla?",
        "Autoguardado",
        {
          confirmButtonText: "Si, recuperar",
          cancelButtonText: "No, gracias",
          type: "info",
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }
      )
      .then(() => {
        try {
          const value = JSON.parse(stored);
          if (fieldname) {
            if (value.hasOwnProperty('employees')) {
              self[ifFound] = true;
              self[ifForm] = value
            } else {
              self[elseFound] = true;
              self[elseForm] = value
            }
          }
        } catch (error) {
          console.error(error);
        }
      })
      .catch(() => {
        localStorage.removeItem(storagekey);
      });
  }
}

const printBoleta = (values, options, selectedPaysheet) => {
  let data = values;
  switch (options.type) {
    case 2:
      data = values
        .filter((v) => options.selection.includes(v.priorDepartment))
        .sort((a, b) => {
          if (a.priorDepartment < b.priorDepartment) return 1;
          if (a.priorDepartment > b.priorDepartment) return -1;
          return 0;
        });
      break;
    case 3:
      data = values.filter((v) => options.selection.includes(v.id));
      break;
  }

  let counter2 = 0;
  const boletas = data.map((e, i) => {
    if ((i + 1) % 3 == 0) {
      counter2 = 0
    }

    let overtime = [['', '']]
    if (e.overtimeList.length > 0) {
      overtime = [
        ...e.overtimeList.map((o) => [
          `(${o.hours}) ${o.name}`,
          {
            text: formatMoney(
              (e.salary  * 12 / 365 / 8) * o.factor * o.hours
            ),
            alignment: "right",
          },
        ])
      ]
    }
    counter2++;
    let employee = [
      { text: "CALDER, SOCIEDAD ANONIMA", alignment: "center", fontSize: 8, margin: [0, counter2 * 10, 0, 0] },
      {
        columns: [
          { fontSize: 8, alignment: 'left', text: `PLANILLA DE ${selectedPaysheet.paysheetType.type.toUpperCase()} N° ${selectedPaysheet.code}` },
          { fontSize: 8, alignment: 'right', text: `PARA EL PERIODO COMPRENDIDO ENTRE ${selectedPaysheet.startDate} AL ${selectedPaysheet.endDate}` },
        ]
      },
      {
        columns: [
          { fontSize: 8, alignment: 'left', text: `EMPLEADO: ${e.fullName}` },
          { fontSize: 8, alignment: 'right', text: `DIAS LABORADOS: ${e.workedDays}` },
        ]
      },
      { text: `DEPARTAMENTO: ${e.priorDepartment}`, alignment: "left", fontSize: 8, margin: [0, 0, 0, 5] },
      {
        layout: "noBorders",
        style: 'tableStyle',
        table: {
          widths: ['*'],
          heights: [165, 25],
          body: [
            [
              {
                layout: "noBorders",
                table: {
                  widths: ["*", "*", "*", 160],
                  body: [
                    ["INGRESOS", "HORAS EXTRA", "DESCUENTOS", "TOTALES"],
                    [
                      {
                        layout: "noBorders",
                        table: {
                          widths: ["*", 50],
                          body: [
                            [
                              "SALARIO:",
                              {
                                text: formatMoney(e.salaryForPayroll),
                                alignment: "right",
                              },
                            ],
                            ...e.gratificationsList.map((g) => [
                              g.name,
                              {
                                text: formatMoney(g.value),
                                alignment: "right",
                              },
                            ]),
                          ],
                        },
                      },
                      {
                        layout: "noBorders",
                        table: {
                          widths: ["*", 50],
                          body: overtime,
                        },
                      },
                      {
                        layout: "noBorders",
                        table: {
                          widths: ["*", 50],
                          body: [
                            [
                              "RENTA:",
                              {
                                text: formatMoney(-e.taxes),
                                alignment: "right",
                              },
                            ],
                            [
                              "AFP:",
                              {
                                text: formatMoney(-e.afpEmployee),
                                alignment: "right",
                              },
                            ],
                            [
                              "IGSS:",
                              {
                                text: formatMoney(-e.socialEmployee),
                                alignment: "right",
                              },
                            ],
                            ...e.discountsList.map((g) => [
                              g.name,
                              {
                                text: formatMoney(g.value),
                                alignment: "right",
                              },
                            ]),
                          ],
                        },
                      },
                      {
                        // layout: "noBorders",
                        table: {
                          widths: ["*", 50],
                          body: [
                            [
                              {
                                text: "TOTAL INGRESOS:",
                                border: [false, false, false, false],
                              },
                              {
                                text: formatMoney(e.subtotalSalary),
                                alignment: "right",
                                border: [false, false, false, false],
                              },
                            ],
                            [
                              {
                                text: "TOTAL DESCUENTOS:",
                                margin: [0, 0, 0, 5],
                                border: [false, false, false, false],
                              },
                              {
                                text: formatMoney(
                                  e.discounts -
                                  e.taxes -
                                  e.afpEmployee -
                                  e.socialEmployee
                                ),
                                alignment: "right",
                                margin: [0, 0, 0, 5],
                                border: [false, false, false, false],
                              },
                            ],
                            [
                              {
                                text: "PAGO NETO",
                                bold: true,
                                border: [false, true, false, false],
                              },
                              {
                                bold: true,
                                text: formatMoney(e.total),
                                alignment: "right",
                                border: [false, true, false, false],
                              },
                            ],
                          ],
                        },
                      },
                    ],
                  ],
                },
              },
            ],
            [
              {
                table: {
                  widths: ["*", 150],
                  body: [
                    [
                      { text: "", border: [false, false, false, false] },
                      {
                        text: "Es conforme",
                        alignment: "center",
                        border: [false, true, false, false],
                      },
                    ],
                  ],
                },
              },
            ]
          ]
        }
      },
    ]

    // if (counter % 3 == 0) {
    //   employee[4] = { pageBreak: "after", ...employee[4] };
    //   counter2 = 0
    // }
    return employee;
  });
  const docDefinition = {
    pageSize: {
      width: 612,
      height: 792
    },
    pageOrientation: "portrait",
    pageMargins: [10, 0, 10, 10],
    content: boletas,
    styles: {
      tableStyle: {
        fontSize: 8,
      },
    },
  };
  pdfMake.createPdf(docDefinition).open();
  // const fonts = {
  //   Roboto: {
  //     normal: 'http://localhost:8080/fonts/dotrice/dotrice-regular.otf',
  //     bold: 'http://localhost:8080/fonts/dotrice/dotrice-bold.otf',
  //     italics: 'http://localhost:8080/fonts/dotrice/dotrice-regular.otf',
  //     bolditalics: 'http://localhost:8080/fonts/dotrice/dotrice-bold.otf'
  //   },
  // }


  // pdfMake.createPdf(docDefinition, null, fonts).open();
}

const checkPermissions = (path, action = null) => {
  // Verifica si es super
  if (store.getters.isSuper) return true

  // Obtiene el modulo y submodulo solicitado
  if (!path) return false
  const [Module, Submodule] = path.split(':')

  // Verifica si el usuario tiene el modulo asignado si no, retorna false
  if (!store.getters.userPermissions) return false
  const moduleFound = store.getters.userPermissions.find(up => up.Module === Module)
  if (!moduleFound) return false

  // Si tiene el modulo asignado verifica que tenga el submodulo solicitado
  const subFound = moduleFound.Submodules.find(sm => sm.Name === Submodule)
  if (!subFound) return false

  // En caso que tenga todos los permisos (*) retorna true
  if (subFound.Permissions === '*') return true

  // Valida el permiso especifico
  return subFound.Permissions.find(p => typeof action === 'string' ? [action].includes(p) : action.includes(p)) !== undefined
}

const hasModule = (Module) => {
  // Verifica si es super
  if (store.getters.isSuper) return true
  if (!Module) return false

  // Verifica si el usuario tiene el modulo asignado si no, retorna false
  if (!store.getters.userPermissions) return false
  const moduleFound = store.getters.userPermissions.find(up => up.Module === Module)
  return moduleFound !== undefined
}

const formatName = (employee) => {
  return `${employee.lastname1 ? employee.lastname1 + ' ' : ''}${employee.lastname2 ? employee.lastname2 : ''}${employee.lastname3 ? ' ' + employee.lastname3 : ''}${employee.name1 ? ', ' + employee.name1 + ' ' : ''}${employee.name2 ? employee.name2 + ' ' : ''}${employee.name3 ? employee.name3 + ' ' : ''}`
}

export {
  inputValidate,
  amountValidate,
  emailValidate,
  sortPropertyName,
  formatMoney,
  formatNumber,
  calcularPension,
  calcularSocial,
  getHeader,
  getFooter,
  checkBeforeEnter,
  checkBeforeLeave,
  printBoleta,
  checkPermissions,
  hasModule,
  formatName
};
